document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".coldbeer-product-card").forEach(productCard => {
    const productDataElement = productCard.querySelector('#coldbeer-product-structured-data');
    const productData = JSON.parse(productDataElement.textContent);
    const variants = productData.variants;

    // Select all variant inputs once and use event delegation
    const variantInputs = productCard.querySelectorAll('.coldbeer-product-card__variants input');
    const productForm = productCard.querySelector('.product-form');
    const variantIdInput = productForm ? productForm.querySelector('input.product-variant-id') : null;

    variantInputs.forEach(input => {
      input.addEventListener('change', function() {
        const cardWrapper = this.closest('.coldbeer-product-card');

        // Collect selected option values
        const selectedOptionIds = Array.from(cardWrapper.querySelectorAll("[data-option-value-id]:checked"))
          .map(option => option.value);

        // Find the matching variant
        const matchedVariant = variants.find(variant =>
          variant.options.every(option => selectedOptionIds.includes(option))
        );

        // Update the variant ID input field
        if (matchedVariant && variantIdInput) {
          variantIdInput.value = matchedVariant.id;
        }

        if (input.classList.contains('swatch-input__input') && matchedVariant.featured_image) {
          // Hide all images initially
          cardWrapper.querySelectorAll('.coldbeer-product-card__media img').forEach(img => img.style.display = 'none');
          // Show the matching image based on selected variant
          cardWrapper.querySelectorAll(`img[data-image-id="${matchedVariant.featured_image.id}"]`)
            .forEach(img => img.style.display = 'block');
        }

        if (matchedVariant && !matchedVariant.available) {
          cardWrapper.querySelector('.product-form__submit').disabled = true;
        } else {
          cardWrapper.querySelector('.product-form__submit').disabled = false;
        }
      });
    });
  });
});

document.querySelectorAll('.coldbeer-product-card__popup-slider.swiper').forEach((swiperElement) => {
  new Swiper(swiperElement, {
    loop: true,
    slidesPerView: 1,
    speed: 700,
    navigation: {
      nextEl: swiperElement.closest('.coldbeer-product-card__popup').querySelector('.coldbeer-product-card__popup-nav-next'),
      prevEl: swiperElement.closest('.coldbeer-product-card__popup').querySelector('.coldbeer-product-card__popup-nav-prev'),
    },
    pagination: {
      el: swiperElement.closest('.coldbeer-product-card__popup').querySelector('.coldbeer-product-card__popup-pagination'),
      type: "bullets",
      clickable: true
    },
  });
});


document.querySelectorAll('.coldbeer-product-card__open-popup').forEach(button => {
  button.addEventListener('click', function () {
    console.log('click');
    this.closest('.coldbeer-product-card').nextElementSibling.classList.add('visible');

    document.querySelector('.coldbeer-product-card__popup-overlay').classList.add('visible');
  });
});

document.querySelectorAll('.coldbeer-product-card__popup-overlay, .coldbeer-product-card__popup-close').forEach(element => {
  element.addEventListener('click', function () {
    document.querySelectorAll('.coldbeer-product-card__popup').forEach(popup => {
      popup.classList.remove('visible');
    });

    document.querySelector('.coldbeer-product-card__popup-overlay').classList.remove('visible');
  });
});